import { createTRPCClient } from '@hs/shared/lib/trpc';
import { store } from '@/stores/store';

/**
 * tRPC 客户端配置
 *
 * ✅ 使用 shared 包的工厂函数创建 tRPC 客户端
 * ✅ 请求头携带 x-space-id（当前空间），与登录/me 的权限空间一致，避免“有权限但接口报缺权限”
 */
// ✅ 统一使用同源相对路径：/api/trpc
// - 开发环境：Vite proxy 转发到本地后端
// - 生产环境：Nginx 将 /api/* 反向代理到后端（浏览器不跨域，不受 CORS 影响）
const isDev = import.meta.env.DEV;
const apiUrl = '/api/trpc';

// ✅ 打印 API URL（便于调试）
if (typeof window !== 'undefined') {
  if (isDev) {
    console.log('[tRPC] 开发环境：使用 Vite proxy');
    console.log('[tRPC] 实际使用的 API URL:', apiUrl);
    console.log('[tRPC] 请求将通过 Vite proxy 转发到: http://localhost:3000/api/trpc');
  } else {
    console.log('[tRPC] 生产环境 API 配置:');
    console.log('[tRPC] 实际使用的 API URL:', apiUrl);
    console.log('[tRPC] ✅ 同源请求 /api/trpc，由 Nginx 反向代理到后端（浏览器不跨域）');
  }
}

export const { trpc, trpcClient, trpcProxyClient } = createTRPCClient({
  apiUrl,
  getToken: () => (typeof window !== 'undefined' ? localStorage.getItem('token') : null),
  getSpaceId: () => {
    const state = store.getState() as { auth?: { user?: { spaces?: Array<{ id: string }> } } };
    return state.auth?.user?.spaces?.[0]?.id ?? null;
  },
});

// 导出 apiUrl，供其他模块使用（如 token 刷新）
export { apiUrl };

